import React, { FC } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import { MediaCollectionVideoPreviewProps } from './utils';
import { ANONYMOUS } from '@/utils/dataLayer';
import {
  ASSET_TYPES,
  generateMuxPlaybackEvents,
} from '@/utils/videoPlayerHelpers';

// for streaming public mux video assets
const MediaCollectionVideoPreview: FC<MediaCollectionVideoPreviewProps> = ({
  muxVideo,
  title,
}) => {
  if (!muxVideo?.muxVideoUpload) return null;

  const { playbackId, duration } = muxVideo.muxVideoUpload;

  const eventProps = generateMuxPlaybackEvents({
    title,
    duration,
    isSigned: false,
    type: ASSET_TYPES.VIDEO,
    viewerId: ANONYMOUS,
  });

  return (
    <div className="container mx-auto lg:h-[480px] lg:w-[854px]">
      <MuxPlayer
        streamType="on-demand"
        title={title || ''}
        playbackId={playbackId}
        metadata={{
          video_id: playbackId,
          video_title: title,
          viewer_user_id: ANONYMOUS,
          env_key: process.env.NEXT_PUBLIC_MUX_ENV_KEY,
          player_name: 'Web Course Preview Video Player',
          // If updates made to the player, update me with either a minor or major version bump
          player_version: '1.0',
          video_content_type: 'trailer',
          video_producer: 'Lovevery',
        }}
        autoPlay
        {...eventProps}
      />
    </div>
  );
};

export default React.memo(MediaCollectionVideoPreview);
